import React from 'react';
import {translate} from './translations';

function Literal({target, lang}) {
	return <>{translate(target, lang)}</>;
}

export default Literal;
